import z from "zod";

import { AVAILABILITY_TIMEOUT_MS } from "@/modules/coaching/shared/consts/availabilityTimeout";
import { apiClient } from "@/modules/shared/utils/apiClient";

export type ResolvePublicBookingResponse = {
  coachId: number;
  coachName: string;
};

const ResolvePublicBookingResponseSchema = z.object({
  coachId: z.number(),
  coachName: z.string(),
});

export const resolvePublicBookingLink = async (
  slug: string,
  code: string,
): Promise<ResolvePublicBookingResponse> => {
  const data = await apiClient.get(
    `/public/coaches/${slug}/coaching-session/${code}`,
    { timeoutMs: AVAILABILITY_TIMEOUT_MS },
  );

  return ResolvePublicBookingResponseSchema.parse(data);
};
